import React, { useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { GET_NEW_TAX_REVENUES_LICENSE } from '../../../../constant';
import * as actions from '../../../../action';

const selectList = ({ api }) => {
  return _.get(api, `${GET_NEW_TAX_REVENUES_LICENSE}.list`) || [];
};

const formatOptions = data => {
  return data.map(item => {
    return {
      label: _.get(item, 'attributes.code'),
      value: _.get(item, 'attributes.code'),
      fullInfo: item,
    };
  });
};

const TaxRevenues = ({
  name,
  onChange,
  value,
  readOnly,
  ordinanceRevisionId,
  isLoading,
  getNewTaxRevenuesLicenseList
}) => {
  const dispatch = useDispatch();
  const list = useSelector(selectList);
  const options = [...formatOptions(list)];

  const findValue =
    value === '' ? '' :
    options.find(item => _.get(item, 'fullInfo.attributes.code') === value) ||
    '';

  useEffect(() => {
    dispatch(
      getNewTaxRevenuesLicenseList({
        tax_revenue_type_id: 1,
        q: value,
        ordinance_revision_id: ordinanceRevisionId,
      })
    );
  }, [value]);

  const handleChange = data => {
    onChange({
      target: {
        name,
        value: data ? data.value : '',
        label: data ? data.label : '',
      },
    });
  };

  const loadOptions = (inputValue, callback) => {
    dispatch(
      getNewTaxRevenuesLicenseList(
        {
          tax_revenue_type_id: 1,
          q: inputValue,
          ordinance_revision_id: ordinanceRevisionId,
        },
        response => {
          callback(formatOptions(_.get(response, 'data')));
        }
      )
    );
  };

  const loadOptionsDebounce = _.debounce(loadOptions, 500);

  return readOnly === true ? (
    <span className="full-input text-uppercase">
      {_.get(findValue, 'label')}
    </span>
  ) : (
    <AsyncSelect
      placeholder="- Select -"
      value={findValue}
      onChange={handleChange}
      defaultOptions={formatOptions(list)}
      loadOptions={loadOptionsDebounce}
      components={{
        IndicatorSeparator: () => null,
      }}
      isLoading={isLoading}
      isClearable
    />
  );
};

TaxRevenues.defaultProps = {
  name: undefined,
  readOnly: undefined,
};

TaxRevenues.propTypes = {
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  ordinanceRevisionId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getNewTaxRevenuesLicenseList: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, 'loading', []).indexOf(GET_NEW_TAX_REVENUES_LICENSE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxRevenues);
